import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IApiResult } from "../shared/models/api-result";
import { IRosterProject } from "../shared/models/roster/roster-project";
import { IRosterSummaryLine } from "../shared/models/roster/roster-summary-line";
import { ApiUrlProvider } from "./api-url.provider";

@Injectable({
  providedIn: "root"
})
export class RosterProjectService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IRosterProject[]>>{
    return this.http.get<IApiResult<IRosterProject[]>>(`${this.apiUrlProvider.url}/RosterProject`);
  }

  add(entity: IRosterProject): Observable<IApiResult<IRosterProject>>{
    return this.http.post<IApiResult<IRosterProject>>(`${this.apiUrlProvider.url}/RosterProject`, entity);
  }

  update(entity: IRosterProject): Observable<IApiResult<IRosterProject>>{
    return this.http.post<IApiResult<IRosterProject>>(`${this.apiUrlProvider.url}/RosterProject/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/RosterProject/${entityId}/delete`, null);
  }

  deleteGroup(entity: IRosterProject): Observable<IApiResult<IRosterProject>>{
    return this.http.post<IApiResult<IRosterProject>>(`${this.apiUrlProvider.url}/RosterProject/${entity.id}/DeleteGroup`, entity);
  }
 
}
